export const resume = {
	title: "Summary",
	description:
		"Check that all the information is correct and then publish the promotion. It will automatically activate and be ready to use.",
	sections: {
		allProducts: "All products",
		andMore: "and more {{count}} products",
		promotionInfo: {
			title: "Promotion data",
			name: "Name",
			description: "Description",
			maxUses: {
				label: "Quantities of uses per gain",
				uses: "{{uses}} uses",
				withoutLimits: "No Boundaries",
			},
			places: "Locations",
		},
		goals: {
			title: "Goals",
			frequency: "Recurrence of earnings",
		},
		awards: {
			title: "Awards",
			discount: "Discount(%) on the value of the product",
			products: "Discount products",
		},
		usageConditions: "Conditions of use",
	},
};
